import Cookies from 'js-cookie';

const SKIPPED_ONBOARDING = 'skipped-onboarding';

const Onboarding = {};

/**
 * @name hasSkipped
 * @description
 * User has skipped the onboarding.
 */

Onboarding.hasSkipped = () => Cookies.get(SKIPPED_ONBOARDING) === 'true';

/**
 * @name skip
 * @description
 * Method that skips the onboarding.
 */

Onboarding.skip = () => Cookies.set(SKIPPED_ONBOARDING, true);

/**
 * @name unskip
 * @description
 * Method that skips the onboarding.
 */

Onboarding.unskip = () => Cookies.remove(SKIPPED_ONBOARDING);

export default Onboarding;
